export default __webpack_public_path__ + "static/media/pharmacy.415d109c.png";